import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Shield } from 'lucide-react';
import Button from '../ui/Button';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Kurze Verzoegerung damit die Seite erst laden kann
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      necessary: true,
      timestamp: new Date().toISOString()
    }));
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          className="fixed bottom-0 left-0 right-0 z-[9999] p-3 sm:p-4"
        >
          <div className="max-w-2xl mx-auto bg-surface rounded-xl shadow-token-lg border border-border p-4 sm:p-5">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
              <div className="flex-1 flex items-start gap-3">
                <Shield className="w-5 h-5 text-muted-foreground/70 flex-shrink-0 mt-0.5" />
                <p className="text-sm text-muted-foreground leading-relaxed">
                  Diese Website verwendet nur technisch notwendige Cookies.{' '}
                  <a
                    href="/datenschutz"
                    className="text-primary hover:text-primary-hover underline"
                  >
                    Datenschutz
                  </a>
                </p>
              </div>
              <Button
                size="sm"
                onClick={acceptCookies}
                className="w-full sm:w-auto touch-manipulation flex-shrink-0"
              >
                Verstanden
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
